import React from 'react'
import "./Header.css"
import TeslaLogo from '../assets/images/teslaLogoSmall.svg'
import Menu from './Menu.js'

const Header = ({models, modely, modelx, model3, solarroof, solarpanel, shop, account}) => {
    return (
        <div className="header">
            <div className="header__logo">
                <img src={TeslaLogo} alt=""/>
            </div>

            <div className="header__center">
                <a href="https://www.tesla.com/models">MODEL S</a>
                <a href="https://www.tesla.com/model3">MODEL 3</a>
                <a href="https://www.tesla.com/modelx">MODEL X</a>
                <a href="https://www.tesla.com/modely">MODEL Y</a>
                <a href="https://www.tesla.com/solarroof">SOLAR ROOF</a>
                <a href="https://www.tesla.com/solarpanels">SOLAR PANELS</a>
            </div>

            <div className="header__right">
                <a href="https://shop.tesla.com/us/en.html?tesref=true">Shop</a>
                <a href="https://www.tesla.com/teslaaccount">Tesla Account</a>
                <i class="fas fa-bars" onClick={()=>{<Menu />}}></i>
            </div>
            
        </div>  
    )
}

export default Header
